var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassEmptyState",
    {
      attrs: {
        illustrationPath: "/ressources/logged/img/illustrations/no-results.svg",
        caption: _vm.translations.caption
      }
    },
    [
      _c("CompassButton", {
        attrs: { label: _vm.translations.actions.reset_filters },
        on: {
          click: function($event) {
            return _vm.$emit("reset-filters")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }